import React from 'react';

import { Skeleton } from '#/components/ui';

const CompanyDetailsSkeleton = () => {
    return (
        <div className='flex flex-col gap-4'>
            <div className='flex gap-5'>
                <Skeleton className='w-[70px] h-[70px] rounded-xl' />
                <div className='flex flex-col gap-3'>
                    <Skeleton className='h-6 w-40 rounded-md' />
                    <div className='flex gap-2'>
                        {[...Array(3)]?.map((_, i) => (
                            <Skeleton key={i} className='w-7 h-7 rounded-full' />
                        ))}
                    </div>
                </div>
            </div>
            <Skeleton className='h-36 w-full rounded-xl' />
            <Skeleton className='h-4 w-3/4' />
            <Skeleton className='h-4 w-2/4' />
        </div>
    );
};

export { CompanyDetailsSkeleton };
